import { FC } from 'react';
import Link from '@base/lib/Link';
import cn from 'classnames';
import { RouteEnum } from 'pro/config/routers';
import { LoopRender } from '@base/snippets/LoopRender';

const list = [
    { title: 'Terms of Use', url: RouteEnum.TERMS_OF_USE },
    { title: 'Privacy Policy', url: RouteEnum.PRIVACY_POLICY },
];

export const FooterHelp: FC = () => {
    return (
        <LoopRender
            tag={false}
            list={list}
            render={(item, {last}) => (
                <Link
                    className={cn({'mr-20': !last})}
                    href={item.url}
                >
                    {item.title}
                </Link>
            )}
        />
    )
};
